import { Record } from 'immutable';
import { INITIATED, INITIATION_ERROR, MAX_ERROR_COUNT } from 'app/models/banners/constants';

const BannerState = Record({
  initiated: false,
  errorCount: 0,
});

const reducer = (state = new BannerState(), action) => {
  const { type } = action;

  if (type === INITIATED) {
    return state.set('initiated', true);
  } else if (type === INITIATION_ERROR) {
    const { errorCount } = state;

    if (errorCount < MAX_ERROR_COUNT) {
      return state.merge({ initiated: false, errorCount: errorCount + 1 });
    }
  }

  return state;
};

export default reducer;
